import {Injectable} from "@angular/core";
import {OrderCrudComponent} from "../../../crystal-clear/support/order-crud/order-crud.component";
import {FieldRecord} from "../../../model/api/field-record";
import {Order} from "../../../model/clearing/order";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {StringUtils} from "../../../utils/stringUtils";
import {Trade} from "../../../model/clearing/trade";
import {CommRate} from "../../../model/billing/comm-rate";
import {IBrokerageRelated} from "../../../model/clearing/i-brokerage-related";

@Injectable({
  providedIn: 'root'
})
export class SupportOrderDataLoadingService {

  openCloses: FieldRecord<any>[];
  sides: FieldRecord<any>[];
  orderStates: FieldRecord<any>[];
  callPuts: FieldRecord<any>[];
  agressors: FieldRecord<any>[];
  strategies:  FieldRecord<any>[];
  brokerageRules: FieldRecord<any>[];
  thirdPartySystemFeeStatus: FieldRecord<any>[];

  loadData(component: OrderCrudComponent) {
    this.openCloses = Object.keys(AccountDefinition.OpenClose).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.sides = Object.keys(Trade.Side).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.orderStates = Object.keys(Order.OrderState).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.callPuts = Object.keys(Trade.CallPut).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.strategies = Object.keys(Order.Strategy).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.brokerageRules = Object.keys(CommRate.RuleType).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.thirdPartySystemFeeStatus = Object.keys(IBrokerageRelated.FeeStatus).map(key => new FieldRecord(key, StringUtils.humanize(key)));

    component.tracker.incrementTotal();
    component.tracker.incrementDone();
  }

}
